<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { LOCALES, setLocale } from '../i18n'

const { locale, t } = useI18n()
</script>

<template>
  <select :value="locale" :aria-label="t('common.language')" class="locale" @change="setLocale(($event.target as HTMLSelectElement).value)">
    <option v-for="l in LOCALES" :key="l" :value="l">{{ t(`locales.${l}`) }}</option>
  </select>
</template>

<style scoped>
.locale {
  width: auto;
  min-height: 2rem;
  padding: 0.2rem 0.5rem;
  font-size: 0.85rem;
}
</style>
